(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ProblemListDeleteController',ProblemListDeleteController);

    ProblemListDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProblemList'];

    function ProblemListDeleteController($uibModalInstance, entity, ProblemList) {
        var vm = this;

        vm.problemList = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProblemList.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
